import { apiFetch } from './api';

export async function getArmPositions(): Promise<void> {
  await apiFetch('/user/idle/get_arm_positions', { method: 'POST' });
}
